import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import PdfWage from './PdfWage';
import { listDocuments } from '../../actions/wage/listWage';
import LoadingOverlay from 'react-loading-overlay';
import BeatLoader from 'react-spinners/BeatLoader';
import i18next from 'i18next';
import { withNamespaces } from 'react-i18next';
import { documentPayroll } from '../../actions/wage/detailPayroll';
import styles from '../../styles/listWage.module.css';
import $ from 'jquery';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf } from "@fortawesome/pro-solid-svg-icons";

class ListWage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            document: [],
            title: '',
            openPdf: false,
            isActive: true,
            documentType: this.props.documentType,
            documentFolder: this.props.documentFolder
        };
    }

    componentDidMount() {
        this.loadData();
        this.resizeList();
    }

    loadData() {
        listDocuments(this.state.documentType, this.state.documentFolder).then((response) => {
            if (response == null) return;
            const list = JSON.parse(response.list);
            this.setState({ data: list }, () => {
                setTimeout(() => {
                    this.setState({ isActive: false })
                }, 1500);
            });
        });
    }

    loadDocument = (uid) => {
        return new Promise(resolve => {
            documentPayroll(uid).then((response) => {
                const document = JSON.parse(response.document).documentDataBase64;
                this.setState({ document: document }, () => resolve());
            });
        })
    }

    handleClick = async (documentGuid, title) => {
        this.setState({ isActive: true });

        if (documentGuid != null) {
            await this.loadDocument(documentGuid);
            this.setState({ isActive: false, openPdf: true, title: title });
            return;
        }

        this.setState({ isActive: false });
    }

    handleClosePdf = () => {
        this.setState({ openPdf: false });
    };

    resizeList() {
        setTimeout(function () {
            const height = window.innerHeight;
            const titleBar = $('#appBarTitle').height();
            const header = $('div[data-id=headerSchedule]').height();
            const offSet = 50;

            const customHeight = height - header - titleBar - offSet;

            $('div[data-id=listWage]').css('height', `${customHeight}px`);
            //$('div[data-id=listWage]').css('overflow-x', `hidden`);
        }, 1000);
    }

    render() {
        return (
            <LoadingOverlay
                active={this.state.isActive}
                spinner={<BeatLoader />}
                text={i18next.t('punch:form.loading')}
            >
                <div data-id="listWage" className={styles.konekCard}>
                    <List>
                        {this.state.data !== null && this.state.data.map((obj, index) =>
                            <React.Fragment key={index}>
                                <ListItem key={index} button className="listItem" onClick={() => this.handleClick(obj.documentGuid, obj.title)}>
                                    <ListItemIcon className={styles.iconList}>
                                        <FontAwesomeIcon icon={faFilePdf} style={{ width: "25px", height: "25px", marginRight: "5px" }} />
                                    </ListItemIcon>
                                    <ListItemText primary={obj.title} />
                                </ListItem>
                            </React.Fragment>
                        )}
                    </List>
                    <PdfWage
                        open={this.state.openPdf}
                        onClose={this.handleClosePdf}
                        pdfData={this.state.document}
                        filename={`${this.state.title}.pdf`}
                        required={false}
                        title={this.state.title} />
                </div>
            </LoadingOverlay>
        )
    }
}

export default withNamespaces(['wage'], { wait: true })(ListWage);